import { render, staticRenderFns } from "./PaymentProcess.vue?vue&type=template&id=4884f20e&scoped=true&"
import script from "./PaymentProcess.vue?vue&type=script&lang=js&"
export * from "./PaymentProcess.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProcess.vue?vue&type=style&index=0&id=4884f20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884f20e",
  null
  
)

export default component.exports